module.exports = __webpack_public_path__ + "static/media/checkmark.53987d40.svg";